import { Pipe } from "@angular/core";
import { ObjectTypeEnum } from "../../services/tree-to-remove.common.service";

@Pipe({
  name: 'treeToRemoveTrunkCircumference130Label',
  standalone: true
})
export class TreeToRemoveTrunkCircumference130LabelPipe {
  public transform(objectType?: ObjectTypeEnum | null): string {
    switch (objectType) {
      case 'shrub': {
        return 'Powierzchnia krzewu (m²)';
      }
      default: {
        return '<small>(Jeśli wielopniowe, to wartości są po przecinku)</small><br>Obwód pnia na wysokości 130 cm';
      }
    }
  }
}
